import { ICustomizerState } from "./customizer/customizerReducer";
import { IMessagesState } from "./messages/messages.types";
import { initialMessagesState } from "./messages/messagesState";
import { IStudentState } from "./student/student.types";
// import { IAutomobilePolicyRiskLocationState, defaultAutomobilePolicyRiskLocationState } from "./automobilePolicyRiskLocation/automobilePolicyRiskLocation.types";
import { defaultCommonState, ICommonState } from "./common/common.types";

import { IUsersState } from "./UserProfileList/userProfile.types";
import { initialUserProfileState } from "./UserProfileList/userprofileState";

import {
  IAcitivtyState,
  initialAcitvityState,
} from "./activity/activity.types";
import { ILeadsState, initialLeadState } from "./leads/leads.types";
import { defaultOpportunityState } from "./opportunites/deafaultState";
import { IOpportunityState } from "./opportunites/opportunites.types";
import { IGenAiState } from "./genAi/genAi.types";
import { defaultGenAiState } from "./genAi/deafaultState";
import { IOnboardingChecklistState } from "./onboardingChecklist/onboardingChecklist.types";
import { defaultOnboardingChecklistState } from "./onboardingChecklist/defaultState";
import { IReviewQuestionnaireState } from "./ReviewQuestionnaire/ReviewQuestionnaire.types";
import { defaultReviewQuestionnaireState } from "./ReviewQuestionnaire/deafaultState";
import {
  initialSecurityState,
  ISecurityState,
} from "./security/security.types";
import { defaultStudentState } from "./student/studentState";
import {
  initialTemplateState,
  ITemplateState,
} from "./templates/templates.types";

import {
  defaultUserDocument,
  defaultUserDocumentState,
} from "./userDocument/userDocument.state";
import {
  IUserDocument,
  IUserDocumentState,
} from "./userDocument/userDocument.types";
import { IUserBranchState } from "./userBranch/userBranch.types";
import { defaultUserBranchState } from "./userBranch/userBranch.state";
import {
  IEnvConfigState,
  initialEnvConfigState,
} from "./envConfig/envConfig.types";
import {
  ICompanyInformationState,
  initialCompanyInformation,
} from "./CompanyInformation/companyInformation.types";
import { IBookingState, initialBookingState } from "./booking/booking.types";
import {
  ICategoryState,
  initialCategoryState,
} from "./category/category.types";
import {
  ICategoryTypeState,
  initialCategoryTypeState,
} from "./categoryType/categoryType.types";

import {
  IMarketCampaignState,
  initialMarketCampaignState,
} from "./marketCampaign/marketCampaign.types";
import { IGoogleReviewState } from "./Review/review.types";
import { defaultGoogleReviewState } from "./Review/review.state";
import { ICompanyOutletState } from "./companyOutlet/companyOutlet.types";
import { initialCompanyOutletState } from "./companyOutlet/defaultState";
import { IPaymentDetailsState } from "./paymentDetails/paymentDetails.types";
import { initialPaymentDetailsState } from "./paymentDetails/defaultState";
import { IMetaDataState } from "./metaData/metaData.types";
import { initialMetaDataState } from "./metaData/defaultState";
import { IBankDetailsState } from "./bankDetails/bankDetails.types";
import { initialBankDetailsState } from "./bankDetails/defaultState";
import { IContactsState, initialContactState } from "./contacts/contacts.types";

import {
  defaultCompanyOutletAttachmentState,
  ICompanyOutletAttachmentState,
} from "./customerVendorAttachment";
import {
  ICompanyOutletAddressState,
  initialCompanyOutletAddressState,
} from "./customerDeliveryAddress";
import { ISubscriptionPlanState } from "./subscription/subscription.types";
import { initialSubscriptionPlanState } from "./subscription/subscription.state";

import { IOrgEnvConfigState } from "./orgEnvConfig/orgEnvConfig.types";
import { initialOrgEnvConfigState } from "./orgEnvConfig/orgEnvConfig.types";

import {
  IAutomationState,
  initialAutomationState,
} from "./automation/automation.types";
import { IStatusState, initialStatusState } from "./status/status.types";
import { initialFoodState } from "./food/defaultState";
import { IFoodState } from "./food/food.types";
import { IChatbotState, initialChatbotState } from "./chatbot/chatbot.types";
import { ISupportState } from "./support/support.types";
import { initialSupportState } from "./support/defaultState";

import { IMasterFormsState } from "./masterForm/masterForms.types";

import { initialMasterFormsState } from "./masterForm/defaultState";
import { IServiceState } from "./service/service.types";
import { initialServiceState } from "./service/defaultState";
import { IRoomState } from "./room/room.types";
import { initialRoomState } from "./room/defaultState";
import { IEventState } from "./event/event.types";
import { initialEventState } from "./event/defaultState";
import { IFormsState } from "./dynamicFormsV2/forms.types";
import { initialFormsState } from "./dynamicFormsV2/defaultState";
import { IWhatsAppTemplateState } from "./whatsappTemplate/whatsappTemplate.types";
import { initialWhatsAppTemplateState } from "./whatsappTemplate/defaultState";
import { initialActionItemState } from "./actionItems/actionItem.state";
import { IActionItemsState } from "./actionItems";
import { IQuickReplyTemplateState } from "./quickReplyTemplates/quickReplyTemplate.types";
import { initialQuickReplyTemplateState } from "./quickReplyTemplates/defaultState";
import { IMasterQuickReplyTemplateState } from "./masterQuickReplyTemplates/masterQuickReplyTemplate.types";
import { initialMasterQuickReplyTemplateState } from "./masterQuickReplyTemplates/defaultState";
import { initialActionItemCategories } from "./ActionItemCategory/defaultState";
import { IActionItemCategories } from "./ActionItemCategory/ActionItemCategory.types";
import { initialActionItemDynamicForms } from "./actionItemDynamicForm/defaultState";
import { IActionItemDynamicForms } from "./actionItemDynamicForm/actionItemDynamicForm.types";
import { initialUpsellLeadsState } from "./upsellLead/defaultState";
import { IUpsellLeadsState } from "./upsellLead/upsellLeads.types";
import { IVariantsState } from "./variants/variants.types";
import { initialVariantsState } from "./variants/defaultState";
import { IIntents } from "./Intents/Intents.types";
import { initialIntents } from "./Intents/defaultState";
import { ICatalogsState } from "./Catalogs/Catalogs.types";
import { initialCatalogsState } from "./Catalogs/defaultState";
import { IRestrictedWords } from "./restrictedWords/restrictedWords.types";
import { initialRestrictedWords } from "./restrictedWords/defaultState";
import { IReportRevenue } from "./Report/Report.types";
import { initialReportRevenue } from "./Report/defaultState";
import { IMessageSequencesState } from "./MessageSequence/MessageSequence.types";
import { initialMessageSequenceState } from "./MessageSequence/defaultState";
import { ISequenceDebugState } from "./SequenceDebug/SequenceDebug.types";
import { initialSequenceDebugState } from "./SequenceDebug/defaultState";
import { IModuleSettingState, initialModuleSettingState } from "./moduleSetting/moduleSetting.types";
import { IAgentToolsState } from "./AgentTools/AgentTools.types";
import { initialAgentToolsState } from "./AgentTools/defaultState";
import { ICatalogProductsState } from "./CatalogProducts/CatalogProducts.types";
import { defaultCatalogProductsState } from "./CatalogProducts/defaultState";
import { IExternalLeadStatusState } from "./external-leads";
import { defaultExternalLeadStatusState } from "./external-leads/external-leads-life-cycle/external-lead-status.state";


export interface IDropdownListType {
  key: string;
  text: string;
  value: string;
}

export interface IStoreState {
  customizerReducer: ICustomizerState;
  student: IStudentState;
  message: IMessagesState;
  acitivty: IAcitivtyState;
  security: ISecurityState;

  userprofile: IUsersState;
  common: ICommonState;
  templates: ITemplateState;

  companyInformation: ICompanyInformationState;

  opportunites: IOpportunityState;
  leads: ILeadsState;
  genAi: IGenAiState;
  reviewQuestionnaire: IReviewQuestionnaireState;

  userDocument: IUserDocumentState;
  userBranch: IUserBranchState;
  envConfig: IEnvConfigState;
  booking: IBookingState;

  category: ICategoryState;

  categoryType: ICategoryTypeState;
  food: IFoodState;
  marketCampaign: IMarketCampaignState;
  review: IGoogleReviewState;
  companyOutlet: ICompanyOutletState;
  bankDetails: IBankDetailsState;
  contacts: IContactsState;
  companyOutletAddress: ICompanyOutletAddressState;
  companyOutletAttachment: ICompanyOutletAttachmentState;
  payment_details: IPaymentDetailsState;
  metaData: IMetaDataState;
  subscriptionPlan: ISubscriptionPlanState;
  orgEnvConfig: IOrgEnvConfigState;
  automation: IAutomationState;
  status: IStatusState;
  // metaTemplate: IMetaTemplateState;
  whatsappTemplate: IWhatsAppTemplateState;
  quickReplyTemplate: IQuickReplyTemplateState;
  masterQuickReplyTemplate: IMasterQuickReplyTemplateState;
  chatbot: IChatbotState;
  support: ISupportState;

  forms: IFormsState;
  masterForms: IMasterFormsState;
  service: IServiceState;
  event: IEventState;

  actionItems: IActionItemsState;
  restrictedWords: IRestrictedWords;
  intents: IIntents;
  catalogs: ICatalogsState;
  actionItemCategories: IActionItemCategories;
  actionItemDynamicForms: IActionItemDynamicForms;
  upsellLeads: IUpsellLeadsState;
  variants: IVariantsState;
  reportRevenue: IReportRevenue;
  messageSequence: IMessageSequencesState;
  sequenceDebug: ISequenceDebugState;
  moduleSetting: IModuleSettingState;
  room: IRoomState;
  agentTools: IAgentToolsState;
  catalogProducts: ICatalogProductsState;
  onboardingChecklist: IOnboardingChecklistState;
  externalLeads: {
    statusLifeCycle: IExternalLeadStatusState
  }
  //HR

}

export const initialStoreState: IStoreState = {
  //if you want to change the theme of framework, first go to themevariable.ts file, and set your theme there, then come in this file and simply put your theme in activveTheme
  customizerReducer: {
    activeDir: "ltr",
    activeNavbarBg: "#0b70fb", // This can be any color,
    activeSidebarBg: "#ffffff", // This can be any color
    activeMode: "light", // This can be light or dark
    activeTheme: "FEE_MANAGEMENT_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
    SidebarWidth: 240,
    sidebarOpen: true,
  },

  student: defaultStudentState,
  message: initialMessagesState,
  templates: initialTemplateState,
  security: initialSecurityState,

  common: defaultCommonState,
  acitivty: initialAcitvityState,

  userprofile: initialUserProfileState,

  companyInformation: initialCompanyInformation,

  opportunites: defaultOpportunityState,
  leads: initialLeadState,
  genAi: defaultGenAiState,
  reviewQuestionnaire: defaultReviewQuestionnaireState,

  userDocument: defaultUserDocumentState,
  userBranch: defaultUserBranchState,

  envConfig: initialEnvConfigState,
  booking: initialBookingState,

  category: initialCategoryState,

  categoryType: initialCategoryTypeState,
  food: initialFoodState,
  marketCampaign: initialMarketCampaignState,
  review: defaultGoogleReviewState,
  companyOutlet: initialCompanyOutletState,
  bankDetails: initialBankDetailsState,
  contacts: initialContactState,
  companyOutletAddress: initialCompanyOutletAddressState,
  companyOutletAttachment: defaultCompanyOutletAttachmentState,

  payment_details: initialPaymentDetailsState,
  metaData: initialMetaDataState,
  subscriptionPlan: initialSubscriptionPlanState,
  orgEnvConfig: initialOrgEnvConfigState,
  automation: initialAutomationState,
  status: initialStatusState,
  // metaTemplate: initialMetaTemplateState,
  whatsappTemplate: initialWhatsAppTemplateState,
  quickReplyTemplate: initialQuickReplyTemplateState,
  masterQuickReplyTemplate: initialMasterQuickReplyTemplateState,
  chatbot: initialChatbotState,
  support: initialSupportState,
  forms: initialFormsState,
  masterForms: initialMasterFormsState,
  service: initialServiceState,
  event: initialEventState,
  restrictedWords: initialRestrictedWords,
  actionItems: initialActionItemState,
  intents: initialIntents,
  catalogs: initialCatalogsState,
  actionItemCategories: initialActionItemCategories,
  actionItemDynamicForms: initialActionItemDynamicForms,
  upsellLeads: initialUpsellLeadsState,
  variants: initialVariantsState,
  reportRevenue: initialReportRevenue,
  messageSequence: initialMessageSequenceState,
  sequenceDebug: initialSequenceDebugState,
  moduleSetting: initialModuleSettingState,
  room: initialRoomState,
  agentTools: initialAgentToolsState,
  catalogProducts: defaultCatalogProductsState,
  onboardingChecklist: defaultOnboardingChecklistState,
  externalLeads: {
    statusLifeCycle: defaultExternalLeadStatusState
  }
};

